import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-elements';

const ContactInfo: React.FC = () => {
  return (
    <View style={styles.bottomInfo}>
      <Card containerStyle={styles.cardContainer}>
        <Card.Title style={styles.title}>RESOURCE LINKS</Card.Title>
        <Text style={styles.body}>
          <a href="https://www.zonetail.com/contact/">CAREERS</a>
        </Text>
        <Text style={styles.body}>
          <a href="https://www.zonetail.com/investors/">WHY INVEST?</a>
        </Text>
        <Text style={styles.body}>
          <a href="https://www.zonetail.com/investors/">INVESTOR DECK</a>
        </Text>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  bottomInfo: {
    display: 'flex',
    flexDirection: 'column',
    paddingHorizontal: 0,
    maxWidth: 1200,
    margin: 'auto',
  },
  cardContainer: {
    flex: 1,
    borderWidth: 0,
    marginHorizontal: 15,
    paddingHorizontal: 0,
  },
  title: {
    textAlign: 'left',
    color: '#303133',
    fontSize: 20,
    fontWeight: 'bold',
  },
  body: {
    color: '#777777',
  },
});

export default ContactInfo;
